import { Numeric5CircleIcon } from './Numeric5CircleIcon';

/**
 * author: Contributors
 * id B4079A0A-5D66-4982-B31F-4145B49E5512
 * name numeric-5-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-5-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericFiveCircleIcon = Numeric5CircleIcon;
export default NumericFiveCircleIcon